(function() {
	var priceElementCache = {};
	function findElement(id) {
		if (!priceElementCache[id]) {
			var tmp = $('#'+ id);
			priceElementCache[id] = {
				'input': tmp,
				'input_with': $('#' + id + '_with'),
				'base': $('#' + id + '_base'),
				'parent': tmp.parents('.priceWrap'),
				'percent': $('#' + id + '_percent'),
				'tax': $('#' + id + '_tax'),
			};
		}

		return priceElementCache[id];
	}

store.admin.initTax = function() {
	const $taxValues = $('#taxValues');
	if (!$taxValues.length) {
		return;
	}
	const taxValueJson = JSON.parse($taxValues.val());
	$('#taxRuleGroupId').on('change', function() {
		const value = $(this).val();
		const taxValue = taxValueJson[value];
		$('#value_tax').html(taxValue);
		$('#value_with').trigger('keyup');
	});
};

store.admin.priceElementKeyTimeout = 50;
store.admin.priceElementFormSubmit = false;
store.admin.initPriceElement = function(name) {
	var eWithout = $('#' + name).attr('data-pc-updating', 0);
	var eWith = $('#' + name + '_with').attr('data-pc-updating', 0);
	var eWithoutTimeout = null;
	var eWithTimeout = null;

	eWithout.keyup(function(){
		clearTimeout(eWithoutTimeout);
		this.dataset.pcUpdating = "1";
		var id = this.id;
		eWithoutTimeout = setTimeout(function() {
			store.admin.priceCalcWithout(id);
		}, store.admin.priceElementKeyTimeout);
	});
	eWith.keyup(function(){
		clearTimeout(eWithTimeout);
		this.dataset.pcUpdating = "1";
		var id = this.id;
		eWithTimeout = setTimeout(function() {
			store.admin.priceCalcWith(id);
		}, store.admin.priceElementKeyTimeout);
	});
	if (!store.admin.priceElementFormSubmit) {
		var timeout = null;
		var haveRun = false;
		eWith.parents('form').submit(function(e){
			if (haveRun) {
				return;
			}
			haveRun = true;
			if (document.querySelectorAll('[data-pc-updating="1"]').length) {
				clearTimeout(timeout);
				var form = this;
				e.preventDefault();
				timeout = setTimeout(function() {
					const submitBtn = form.querySelector('[type="submit"]');
					//try to execute the default submit with all attached events
					if (submitBtn) {
						submitBtn.click();
					}
					else {
						form.submit();
					}
				}, store.admin.priceElementKeyTimeout*2);
			}
		});
		store.admin.priceElementFormSubmit = true;
	}
};
store.admin.initPriceElements = function(names) {
	if (names && names.length) {
		for (var i = 0, c = names.length; i < c; i++) {
			var id = names[i];
			if (id) {
				store.admin.initPriceElement(id);
			}
		}
	}
};

store.admin.priceCalcWithout = function(id) {
	var elements = findElement(id);
	var ret = '';
	var val = store.admin.trim(elements.input.val());
	elements.parent.find('.becomes').html('');
	if (val.indexOf('%') !== -1) {
		ret = val;
		var percentVal = store.admin.parseFloat(val.replace('%',''));
		if (elements.base.length === 1) {
			var baseValue = elements.base.val();
			elements.parent.find('.without .becomes').html((1-percentVal/100)*baseValue);
			var tax1 = store.admin.parseFloat(elements.tax.text());
			elements.parent.find('.with .becomes').html((1-percentVal/100)*store.admin.floatFormat(store.admin.taxCalculate(baseValue, tax1)));
		}
	}
	else if (val !== '') {
		var without = store.admin.parseFloat(val);
		if (!isNaN(without)) {
			var tax = store.admin.parseFloat(elements.tax.text());
			ret = store.admin.floatFormat(store.admin.taxCalculate(without, tax));
		}
		var percentEl = elements.percent;
		if (percentEl.length === 1 && elements.base.length === 1) {
			var percentVal2 = 100 - (without / elements.base.val()) * 100;
			percentEl.val(percentVal2 + '%');
		}
	}
	elements.input_with.val(ret);
	elements.input.attr('data-pc-updating', 0);
};
store.admin.priceCalcWith = function(id) {
	var elements = findElement(id.replace('_with', ''));
	var val = store.admin.trim(elements.input_with.val());
	var ret = '';
	elements.parent.find('.becomes').html('');
	if (val.indexOf('%') !== -1) {
		ret = val;
		var percentVal = store.admin.parseFloat(val.replace('%',''));
		if (elements.base.length === 1) {
			var baseValue = elements.base.val();
			elements.parent.find('.without .becomes').html((1-percentVal/100)*baseValue);
			var tax1 = store.admin.parseFloat(elements.tax.text());
			elements.parent.find('.with .becomes').html((1-percentVal/100)*store.admin.floatFormat(store.admin.taxCalculate(baseValue, tax1)));
		}
	}
	else if (val !== '') {
		var w = store.admin.parseFloat(val);
		if (!isNaN(w)) {
			var tax = store.admin.parseFloat(elements.tax.text());
			ret = store.admin.floatFormat(store.admin.taxCalculateReverse(w, tax));
		}
		var percentEl = elements.percent;
		if (percentEl.length === 1 && elements.base.length === 1) {
			var percentVal2 = 100 - (ret / elements.base.val()) * 100;
			percentEl.val(percentVal2 + '%');
		}
	}
	elements.input.val(ret);
	elements.input_with.attr('data-pc-updating', 0);
};
})();
